import styled from 'styled-components';
import device from '../../../../GlobalDigitalStyle/BreakPoint.style';

export const LiveActivityContainer = styled.div`
	height: 20em;
	@media ${device.screen1680} {
		height: 18em;
	}
	@media ${device.screen1366} {
		height: 16em;
	}
	@media ${device.screen1050} {
		height: 14em;
	}
	.no__live_activity {
		div img {
			width: 60% !important;
		}
	}
	.text__default {
		font-weight: 600;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
	}
	.section-title {
		font-family: 'Manrope-Bold';
		color: #000;
		font-weight: 700;
		font-size: 18px;
		@media ${device.screen1680} {
			font-size: 16px;
		}
		@media ${device.screen1280} {
			font-size: 14.8px;
		}
		@media ${device.screen1050} {
			font-size: 13px;
		}
	}
`;
